module.exports = __webpack_public_path__ + "static/media/redux-logo.19080b3c.png";